// src/ui/styles/glass.css.js
//
// Soft Midnight Glass — Core Design System
// ----------------------------------------
// Provides the base aesthetic for all UI components.
// This is the dense professional variant: subtle, modern,
// premium, and intentionally understated.

import {css} from 'lit';

export const glassStyles = css`
  :host {
    --glass-bg: rgba(20, 20, 25, 0.55);
    --glass-bg-heavy: rgba(15, 15, 20, 0.75);
    --glass-border: rgba(255, 255, 255, 0.08);
    --glass-border-strong: rgba(255, 255, 255, 0.12);

    --glass-radius: 10px;
    --glass-radius-lg: 14px;

    --glass-shadow:
      0 2px 6px rgba(0, 0, 0, 0.35),
      0 4px 12px rgba(0, 0, 0, 0.25);

    --glass-shadow-lg:
      0 4px 12px rgba(0, 0, 0, 0.4),
      0 8px 24px rgba(0, 0, 0, 0.3);

    --glass-backdrop: blur(18px) saturate(140%);

    --accent: #4da3ff;
    --accent-soft: rgba(77, 163, 255, 0.25);

    --transition-fast: 120ms ease;
    --transition-med: 200ms ease;
    --transition-slow: 320ms ease;
  }

  .glass {
    background: var(--glass-bg);
    border: 1px solid var(--glass-border);
    border-radius: var(--glass-radius);
    box-shadow: var(--glass-shadow);
    backdrop-filter: var(--glass-backdrop);
  }

  .glass-heavy {
    background: var(--glass-bg-heavy);
    border: 1px solid var(--glass-border-strong);
    border-radius: var(--glass-radius-lg);
    box-shadow: var(--glass-shadow-lg);
    backdrop-filter: var(--glass-backdrop);
  }

  .glass-hover {
    transition: background var(--transition-med),
                border-color var(--transition-med),
                box-shadow var(--transition-med);
  }

  .glass-hover:hover {
    background: rgba(30, 30, 35, 0.65);
    border-color: rgba(255, 255, 255, 0.14);
    box-shadow:
      0 3px 8px rgba(0, 0, 0, 0.4),
      0 6px 18px rgba(0, 0, 0, 0.3);
  }

  .glass-button {
    cursor: pointer;
    padding: 6px 12px;
    border-radius: var(--glass-radius);
    background: var(--glass-bg);
    border: 1px solid var(--glass-border);
    transition: background var(--transition-fast),
                border-color var(--transition-fast),
                transform var(--transition-fast);
  }

  .glass-button:hover {
    background: rgba(35, 35, 40, 0.65);
    border-color: var(--glass-border-strong);
  }

  .glass-button:active {
    transform: scale(0.97);
    background: rgba(40, 40, 45, 0.7);
  }

  .accent {
    color: var(--accent);
  }

  .accent-bg {
    background: var(--accent-soft);
  }
`;